var _path, _mask, _g, _path2, _path3, _mask2, _g2, _path4, _mask3, _g3, _path5, _mask4, _g4, _path6, _mask5, _g5, _path7, _mask6, _g6, _path8, _mask7, _g7, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenErasing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 299,
    height: 172,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#565657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M58.743 165.317h59.993M66.158 152.945h24.94M49.98 139.801h37.075"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 35,
    height: 35,
    x: 96,
    y: 124,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M108.532 157.009l-8.066-5.346a9.474 9.474 0 01-2.668-13.157l6.801-10.248a9.489 9.489 0 0113.166-2.663l8.067 5.346a9.474 9.474 0 012.667 13.157l-6.8 10.248c-2.823 4.36-8.785 5.566-13.167 2.663z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7D2F9",
    fillRule: "evenodd",
    d: "M93.292 116.17l44.505 4.677-4.791 45.582-44.505-4.678 4.79-45.581z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#585857",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M108.532 157.009c-2.2-1.353-3.808-2.366-4.825-3.04-.776-.514-1.856-1.283-3.241-2.306-4.194-2.999-5.573-8.779-2.668-13.157l6.801-10.248a9.489 9.489 0 0113.166-2.663l8.067 5.346a9.474 9.474 0 012.667 13.157l-6.8 10.248c-2.823 4.36-8.785 5.566-13.167 2.663z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M110.661 154.896c-3.786-2.409-6.272-4.058-7.457-4.947-1.777-1.332-3.351-3.257-3.654-5.321-.263-1.791.431-3.604 1.514-5.236 2.303-3.479 4.179-6.22 5.628-8.221 2.173-3.003 6.878-4.468 10.394-2.139l6.472 4.29a7.601 7.601 0 012.141 10.557"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 37,
    height: 47,
    x: 163,
    y: 18,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M166.124 32.647L190.13 18.4l9.243 5.625-7.757 25.515-18.932 15.458-9.58-14.514 3.02-17.838z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2CF91",
    fillRule: "evenodd",
    d: "M161.632 9.64l44.526 4.68-6.233 59.307-44.527-4.68 6.234-59.306z",
    clipRule: "evenodd"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#565657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M166.124 32.647L190.13 18.4l9.243 5.625-7.757 25.515-18.932 15.458-9.58-14.514 3.02-17.838z",
    clipRule: "evenodd"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 70,
    height: 101,
    x: 110,
    y: 41,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M179.395 52.184l-58.773 89.201-9.66-6.402 56.366-91.297 11.841-2.395.226 10.893z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6D6D6C",
    fillRule: "evenodd",
    d: "M116.344 28.923l70.482 7.408-12.244 116.49-70.481-7.408 12.243-116.49z",
    clipRule: "evenodd"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#565657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M179.395 52.184l-.226-10.893-11.841 2.395-56.366 91.297 9.66 6.402 58.773-89.2z",
    clipRule: "evenodd"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 65,
    height: 103,
    x: 103,
    y: 32,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M166.124 32.647l1.204 11.04-56.366 91.296-7.567-5.015 62.729-97.321z",
    clipRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2CC38",
    fillRule: "evenodd",
    d: "M109.094 20.888l65.669 6.902-12.44 118.356-65.669-6.902 12.44-118.356z",
    clipRule: "evenodd"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#565657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M166.124 32.647l-62.729 97.321 7.567 5.015 56.366-91.297-1.204-11.04z",
    clipRule: "evenodd"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 72,
    height: 98,
    x: 120,
    y: 49,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M128.904 146.944l-8.282-5.56 58.773-89.2.02.944 12.202-3.587-62.713 97.403z",
    clipRule: "evenodd"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2CC38",
    fillRule: "evenodd",
    d: "M125.842 36.862l72.075 7.576L185.908 158.7l-72.075-7.575 12.009-114.263z",
    clipRule: "evenodd"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#565657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M128.904 146.944l62.713-97.403-12.202 3.587-.02-.944-58.773 89.201 8.282 5.559z",
    clipRule: "evenodd"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "f",
    width: 20,
    height: 19,
    x: 190,
    y: 6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M190.13 18.4l7.129-11.604 11.748.121-9.634 17.109-9.243-5.625z",
    clipRule: "evenodd"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6D6D6C",
    fillRule: "evenodd",
    d: "M186.427-1.221l28.881 3.036-3.082 29.327-28.881-3.036 3.082-29.327z",
    clipRule: "evenodd"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#565657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M190.13 18.4l7.129-11.604 11.748.121-9.634 17.109-9.243-5.625z",
    clipRule: "evenodd"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "g",
    width: 32,
    height: 25,
    x: 100,
    y: 125,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M124.718 149.255l-22.704-15.046c-1.893-1.254-2.428-3.902-1.192-5.875l.463-.697c1.255-1.891 3.904-2.426 5.879-1.19l22.704 15.046c1.893 1.255 2.429 3.902 1.192 5.876l-.463.697a4.339 4.339 0 01-5.879 1.189z",
    clipRule: "evenodd"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C1C0BD",
    fillRule: "evenodd",
    d: "M95.59 119.02l44.172 4.643-3.471 33.024-44.172-4.642 3.471-33.025z",
    clipRule: "evenodd"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#585857",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M124.718 149.255l-22.704-15.046c-1.893-1.254-2.428-3.902-1.192-5.875l.463-.697c1.255-1.891 3.904-2.426 5.879-1.19l22.704 15.046c1.893 1.255 2.429 3.902 1.192 5.876l-.463.697a4.339 4.339 0 01-5.879 1.189z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M189.307 22.017l-19.088 11.456"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenErasing);
export default __webpack_public_path__ + "static/media/penErasing.df500d35743d0751df8bf061df7c8edf.svg";
export { ForwardRef as ReactComponent };